import { applicationSubjectPropertyApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SUBJECT_PROPERTY_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/subjectProperty`,
  {
    GET_PROPERTY: 'GET_PROPERTY',
  },
);

export const getSubjectPropertyAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationSubjectPropertyApi.getSubjectProperty(params);

  return dispatch({
    type: SUBJECT_PROPERTY_ACTION_TYPE.GET_PROPERTY,
    payload: data,
  });
});
